export const CircledNumber = ({number}: {number: number}) => {
  return (
    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-borderColor-100 dark:bg-neutral-100 text-brandDarkest dark:text-primary-800 text-lg font-medium">
      {number}
    </div>
  );
}
